import { FormlyFieldConfigMap } from './formly-field-config.map';
import {ConsumerType} from '@emm/core/models/consumer-type.model';

const operatorLocksPlaceHolder = 'Search for an Operator Lock Group or Item';

export const operatorLocksFilterFieldMap: FormlyFieldConfigMap<ConsumerType> = {

    name: () => ({
        key: 'name',
        templateOptions: {
            label: 'Lock Group Name',
            maxLength: 512,
            placeholder: operatorLocksPlaceHolder,
        },
        type: 'input',
        wrappers: ['form-field-filter']
    }),

    tag: () => ({
        key: 'tag',
        templateOptions: {
            label: 'Lock Group Tag',
            maxLength: 512,
            placeholder: operatorLocksPlaceHolder
        },
        type: 'input',
        wrappers: ['form-field-filter']
    })

};
